const useRolesTypes = () => {
  const ADD_ROLE = 'ADD_ROLE';
  const REMOVE_ROLE = 'REMOVE_ROLE';

  return {
    ADD_ROLE,
    REMOVE_ROLE,
  };
};

export default useRolesTypes;
